import {
  parseSupportModeSession,
  type SupportModeSession,
} from "@/context/supportMode/supportModeSession";

export const SUPPORT_MODE_SESSION_STORAGE_KEY = "dxp-support-mode-session";

export const readSupportModeSessionFromStorage =
  (): SupportModeSession | null => {
    try {
      const raw = localStorage.getItem(SUPPORT_MODE_SESSION_STORAGE_KEY);
      if (raw === null) {
        return null;
      }

      return parseSupportModeSession(JSON.parse(raw));
    } catch {
      // corrupt JSON or blocked storage — treat as no persisted session
      return null;
    }
  };

export const writeSupportModeSessionToStorage = (
  session: SupportModeSession | null
): void => {
  try {
    if (session === null) {
      localStorage.removeItem(SUPPORT_MODE_SESSION_STORAGE_KEY);
      return;
    }

    localStorage.setItem(
      SUPPORT_MODE_SESSION_STORAGE_KEY,
      JSON.stringify(session)
    );
  } catch {
    // private mode / blocked storage — in-memory only
  }
};
